import React from 'react';
import ACardComponent from '../../components/ACard';
import Box from '../../components/Box';
import { OverviewLayout } from '../../components/DetailLayout';
import OverviewLayoutAside from '../../components/OverviewLayout/OverviewLayoutAside';
import OverviewLayoutSection from '../../components/OverviewLayout/OverviewLayoutSection';
import Typography from '../../components/Typography';
import useConfig from '../../hooks/config.hooks';
import useDevice, { Device } from '../../hooks/device.hooks';
import { translate, translateHTML } from '../../i18n';

const ACardEmpty: React.FC = () => {
  const device = useDevice();
  const isDesktop = React.useMemo(() => device === Device.DESKTOP, [device]);
  const { ACARD_INFO_URL } = useConfig();

  return (
    <OverviewLayout title="acard.title" noNavigation>
      {isDesktop && (
        <OverviewLayoutAside>
          <Box classNames="u-margin-top">
            <ACardComponent />
          </Box>
        </OverviewLayoutAside>
      )}

      <OverviewLayoutSection>
        <Box>
          {!isDesktop && (
            <div className="u-margin-bottom">
              <ACardComponent />
            </div>
          )}

          <Typography variant="h2" as="h6" classNames="u-margin-bottom">
            {translate('acard.empty.title')}
          </Typography>

          {translateHTML('acard.empty.body')}

          <a href={ACARD_INFO_URL} className="a-button u-margin-top" target="_blank">
            {translate('acard.empty.cta')}
          </a>
        </Box>
      </OverviewLayoutSection>
    </OverviewLayout>
  );
};

export default ACardEmpty;
